<template>
  <div class="g-bd">
    <div class="login-bg"></div>
    <img class="login-ch" src="/images/ch.png" alt="" />

    <!-- 登录模块 -->
    <div class="m-login-box" v-show="!!loginFlag">
      <div class="login-title login-mar">
        <div>
          <h3>用户登录</h3>
        </div>
        <div>
          <span>还没有账号?</span>
          <a @click="toSign">&nbsp;去注册</a>
        </div>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="0">
        <el-form-item label prop="userName">
          <div class>
            <el-input
              prefix-icon="el-icon-mobile-phone"
              v-model.trim="form.userName"
              placeholder="请输入用户名/手机号"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label prop="passWord">
          <div class>
            <el-input
              prefix-icon="el-icon-lock"
              v-model.trim="form.passWord"
              show-password
              placeholder="请输入密码"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label prop="imageCode">
          <div class="login-code">
            <div style="padding-right: 20px">
              <el-input
                prefix-icon="el-icon-bell"
                v-model.trim="form.imageCode"
                placeholder="验证码"
                @keyup.enter.native="onKeydown"
              ></el-input>
            </div>
            <div class="code-img" @click="getCode">
              <img :src="baseImg" alt />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-title login-mar">
        <el-checkbox v-model="rememberMe">记住用户名</el-checkbox>
        <a style="color: #777" href="/getPass">忘记密码?</a>
      </div>
      <div class="login-btn login-mar">
        <el-button type="primary" size :loading="btnLoading" @click="getLogin"
          >登录</el-button
        >
      </div>
    </div>
    <!-- 注册模块 -->
    <div class="m-login-box" ref="sign" v-show="!loginFlag">
      <div class="login-title login-mar">
        <div>
          <h3>用户注册</h3>
        </div>
        <div>
          <span>已有账号?</span>
          <a @click="toLogin">&nbsp;去登录</a>
        </div>
      </div>
      <el-form ref="signForm" :rules="rules1" :model="signForm">
        <el-form-item prop="realName">
          <el-input
            prefix-icon="el-icon-s-order"
            v-model.trim="signForm.realName"
            placeholder="请输入真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userName">
          <el-input
            prefix-icon="el-icon-s-custom"
            v-model.trim="signForm.userName"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="moocRole">
          <el-select
            v-model="signForm.moocRole"
            placeholder="请选择身份"
            style="width: 100%"
          >
            <el-option label="学生" value="0"></el-option>
            <el-option label="教师" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolId">
          <el-select
            v-model="signForm.schoolId"
            filterable
            placeholder="请输入院校名称搜索"
            style="width: 100%"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="email">
          <el-input
            prefix-icon="el-icon-office-building"
            v-model.trim="signForm.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input
            prefix-icon="el-icon-mobile-phone"
            v-model.trim="signForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="imageCode">
          <div class="login-code">
            <div style="padding-right: 20px">
              <el-input
                prefix-icon="el-icon-bell"
                v-model.trim="signForm.imageCode"
                placeholder="请输入图片验证码"
              ></el-input>
            </div>
            <div class="code-img" @click="getCode">
              <img :src="baseImg" alt />
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="messageCode">
          <div class="login-code">
            <div style="padding-right: 20px">
              <el-input
                prefix-icon="el-icon-chat-dot-round"
                v-model.trim="signForm.messageCode"
                placeholder="请输入短信验证码"
              ></el-input>
            </div>
            <el-button
              :type="mobleLoading ? 'info' : 'primary'"
              @click="getMobleCode"
              :disabled="mobleLoading"
              >{{
                mobleLoading == false
                  ? "获取短信验证码"
                  : `${countNum}秒后重新获取`
              }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model.trim="signForm.password"
            show-password
            placeholder="6-16位密码，区分大小写，不能用空格"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password1">
          <div class>
            <el-input
              prefix-icon="el-icon-lock"
              v-model.trim="signForm.password1"
              show-password
              placeholder="请输入确认密码"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-btn login-mar">
        <el-button type="primary" size :loading="btnLoading" @click="getSgin"
          >注册</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// 语义化参数
import Qs from "qs";
// 密码加密
import md5 from "js-md5";
import { mapGetters } from "vuex";

export default {
  data() {
    let pattern1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,16}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!pattern1.test(value)) {
          callback(new Error("请输入6-16位且包含数字，大小写字母三种"));
        }
        // if (this.signForm.password1 !== "") {
        //   this.$refs.signForm.validateField("password1");
        // }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.signForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (this.isGetCode) {
        callback();
      }
      if (value === "") {
        callback(new Error("请输入图片验证码"));
        return;
      }
      let par = {
        code: this.signForm.imageCode,
        token: this.signForm.imageToken,
      };
      var that = this;
      this.$http
        .post("/api/static/checkCaptcha", par)
        .then((res) => {
          that.isGetCode = true;
        })
        .catch(function (error) {
          that.isGetCode = false;
          callback(new Error("图片验证码不正确"));
          that.getCode();
        });
    };
    return {
      loginFlag: true,
      form: {
        // userName: "18758561988",
        userName: "",
        passWord: "",
        imageToken: "",
        imageCode: "",
      },
      signForm: {
        mobile: "",
        realName: "",
        password: "",
        userName: "",
        schoolId: "",
        imageCode: "",
        imageToken: "",
        email: "",
        messageCode: "",
        moocRole: "",
        password1: "",
      },
      schoolList: [],
      baseImg: "",
      rules: {
        userName: [
          { required: true, message: "请输入用户名/手机号", trigger: "blur" },
          // {
          //   pattern: /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9])[0-9]{8}$/,
          //   message: "请输入正确的手机号",
          //   trigger: "blur"
          // }
        ],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
        imageCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      rules1: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            // pattern: /^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/,
            pattern: /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9])[0-9]{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        realName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        schoolId: [
          {
            required: true,
            message: "请选择学校",
            trigger: "change",
          },
        ],
        moocRole: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change",
          },
        ],
        messageCode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        imageCode: [
          {
            required: true,
            validator: validatePass3,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        password1: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur",
          },
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
      isGetCode: false, //图片是否验证成功
      rememberMe: true,
      btnLoading: false,
      mobleLoading: false,
      countNum: 60,
      intervalBtn: {},
    };
  },
  computed: {
    ...mapGetters(["getinviteId"]),
  },
  mounted() {
    if (localStorage.getItem("userName") != null) {
      this.form.userName = localStorage.getItem("userName");
    }
    if (this.$route.query.pathFlag == "true") {
      this.toLogin();
    } else if (this.$route.query.pathFlag == "false") {
      this.toSign();
    }
    this.getCode();
    // this.getCurrentUser();
  },
  // 监听表单内容
  watch: {
    loginFlag(newv) {
      if (newv == false) {
        this.$refs.sign.style = "margin:-8% 0 0 55%";
      }
    },
  },
  methods: {
    getMobleCode() {
      if (
        /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9])[0-9]{8}$/.test(
          this.signForm.mobile
        ) != true
      ) {
        this.$message({
          message: "请先输入正确手机号码",
          type: "warning",
        });
        return;
      }
      if (this.isGetCode == false) {
        this.$message({
          message: "请先验证通过图片验证码",
          type: "warning",
        });
        return;
      }

      let par = {
        phone: this.signForm.mobile,
        type: 1,
        code: this.signForm.imageCode,
        token: this.signForm.imageToken,
      };
      this.$http
        .post("/api/static/getMessageCode", par)
        .then((res) => {
          this.mobleLoading = true;
          this.intervalBtn = setInterval(() => {
            if (this.countNum <= 0) {
              // 重置btn提示信息
              this.mobleLoading = false;
              // 清除定时器
              clearInterval(this.intervalBtn);
              // 更改btn状态
              this.countNum = 60;
            }
            // 倒计时
            this.countNum--;
          }, 1000);
        })
        .catch((msg) => {
          this.$message.error(msg);
        });
    },
    onKeydown(e) {
      console.log(e);
      if (e.keyCode == 13) {
        this.getLogin();
      }
    },
    toLogin() {
      this.$refs["signForm"].resetFields();
      this.loginFlag = true;
      this.$refs["form"].resetFields();
      this.getCode();
    },
    toSign() {
      this.$refs["form"].resetFields();
      this.loginFlag = false;
      this.$refs["signForm"].resetFields();
      this.getCode();
      this.getSchoolList();
    },
    // 获取学校列表
    getSchoolList() {
      let par = {
        pageSize: 500,
        currentPage: 1,
      };
      this.$http
        .post("/api/web/university/list", par)
        .then((res) => {
          this.schoolList = res.data.records;
        })
        .catch((msg) => {
          // console.log(msg);
        });
    },
    // 获取验证码
    getCode() {
      this.$http.post("/api/static/getCaptcha").then((res) => {
        console.log(res);
        this.baseImg = res.data.image;
        if (!!this.loginFlag) {
          this.form.imageToken = res.data.token;
        } else {
          this.signForm.imageToken = res.data.token;
        }
      });
    },
    // 注册
    getSgin() {
      this.$refs["signForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let par = this.signForm;
          this.$http
            .post("/api/web/register", par)
            .then((res) => {
              this.btnLoading = false;
              this.$message({
                message: "注册成功",
                type: "success",
              });
              this.toLogin();
            })
            .catch((msg) => {
              // console.log(msg);
              this.getCode();
              this.btnLoading = false;
              this.$message.error(msg);
            });
        }
      });
    },
    // 登录
    getLogin() {
      // window.location.href = this.$setting.baseURL + "/api/web/casLogin";
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let par = {
            username: this.form.userName,
            password: this.form.passWord,
            imageToken: this.form.imageToken,
            imageCode: this.form.imageCode,
          };
          this.$http
            .post("/api/web/login", par)
            .then((res) => {
              if (!!this.rememberMe) {
                localStorage.userName = this.form.userName;
              } else {
                localStorage.userName = "";
              }
              this.$store.dispatch("login", res.data);
              // window.location.href = res.data.moocLoginUrl;
              this.getCurrentUser(res.data.moocLoginUrl);
              // this.getCurrentUser();
            })
            .catch((msg) => {
              // console.log(msg);
              this.getCode();
              this.btnLoading = false;
              this.$message.error(msg);
            });
        }
      });
    },
    getCurrentUser(val) {
      if (
        !this.$store.getters.getRefreshToken &&
        !this.$store.getters.getAccessToken
      ) {
        this.$store.commit("UPDATE_LOGIN_STATUS", true);
        return;
      }
      this.$http
        .post("/api/web/user/getUserInfo")
        .then((data) => {
          // console.log(data);
          this.btnLoading = false;
          let { msg, code } = data;
          this.$store.dispatch("updateUserInfo", data.data);
          // this.$router.push("/");
          window.location.href = val;
        })
        .catch(({ code, msg }) => {});
    },
  },
  created() {
    // this.getCurrentPhone();
  },
};
</script>

<style scoped lang="scss">
.g-bd {
  padding: 200px 0 60px;
  background: #f7f8f9;
  overflow: hidden;
  .login-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(/images/bg1.png) center no-repeat;
    background-size: cover;
  }
}
.m-login-box {
  position: relative;
  width: 450px;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  margin: 0 0 0 55%;
  .el-form-item {
    margin-bottom: 25px;
  }
  .login-title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h3 {
      font-size: 30px;
      color: #333;
    }

    span {
      font-size: 14px;
      color: #777;
    }
    a {
      cursor: pointer;
      font-size: 14px;
      color: #3685fd;
    }
  }
  .login-mar {
    margin-bottom: 30px;
  }
  .login-code {
    display: flex;
    div {
      flex: 1;
    }
    .code-img {
      width: 140px;
      max-width: 140px;
      cursor: pointer;
      img {
        vertical-align: top;
      }
    }
  }
  .login-btn {
    margin: 30px 0 20px;
    .el-button {
      width: 100%;
      font-size: 16px;
    }
  }
}
// @media (min-width: 768px) {
//   .m-login-box {
//     margin: 100px auto 80px auto;
//   }
// }
// @media (min-width: 992px) {
//   .m-login-box {
//     margin: 100px auto 80px auto;
//   }
// }
// @media (min-width: 1200px) {
//   .m-login-box {
//     margin: 200px auto 80px auto;
//   }
// }
</style>
